<template>
  <div class="echartsPie">
    <div
      class="reprint"
      :ref="`echartsPie${echartsId}`"
    />
    <div
      class="empty"
      v-show="dataList.length===0"
    >
      暂无数据
    </div>
  </div>
</template>

<script>
import { formatNumWidthComma } from '@common/util.js'
import Echarts from 'echarts'
export default {
  props: {
    echartsId: {
      type: String,
      default: () => ''
    },
    dataList: {
      type: Array,
      default: () => []
    },
    color: {
      type: Array,
      default: () => [
        '#3780F7',
        '#EF6D6B',
        '#6CE3D1',
        '#F0F0F0',
        '#15ACFE',
        '#FFD74C',
        '#00CBB4'
      ]
    },
    centerTop: {
      type: String,
      default: '32%'
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        color: [],
        tooltip: {
          trigger: 'item',
          formatter: '{b}：{c}'
        },
        legend: {
          orient: 'vertical',
          left: 0,
          bottom: 10,
          icon: 'circle',
          itemHeight: 4,
          data: [],
          formatter: name => {
            let val = this.dataList.find(item => item.name === name) || {
              value: 0
            }
            let str =
              '{text|' +
              name +
              '}' +
              '{num|' +
              formatNumWidthComma(val.value) +
              '}'
            return str
          },
          textStyle: {
            left: 0,
            rich: {
              num: {
                width: 90,
                fontSize: 16,
                color: '#454647',
                align: 'right',
                padding: [0, 0, 0, 10]
              },
              text: {
                width: 70,
                align: 'left',
                color: '#666666',
                fontSize: 12
              }
            }
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['45%', '60%'],
            center: ['50%', this.centerTop],
            avoidLabelOverlap: false,
            label: {
              normal: {
                padding: [30, 30, 30, 30],
                backgroundColor: '#fff',
                show: false,
                position: 'center',
                formatter: '{percent|{d}%}',
                rich: {
                  percent: {
                    width: 0,
                    height: 0,
                    lineHeight: 0,
                    zIndex: -1,
                    color: '#454647',
                    fontSize: 20

                  }
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    this.myChart = Echarts.init(this.$refs[`echartsPie${this.echartsId}`])
    this.drawLine()
  },
  methods: {
    drawLine() {
      this.myChart.clear()
      this.option.series[0].data = this.dataList
      this.option.legend.data = this.dataList
        .map(item => item.name)
        .slice(0, Math.min(3, this.dataList.length))
      this.option.color = this.color
      this.myChart.setOption(this.option, true)
    }
  },
  watch: {
    dataList: {
      handler(newValue, oldValue) {
        this.drawLine()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.echartsPie {
  position: relative;
  height: 100%;
  .reprint {
    height: 100%;
  }
  .empty{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-10px, -6px);
    font-size: 12px;
    color:#999;
  }
}
</style>
